import React, { createContext, useCallback, useContext, useState } from 'react';
import client, { apiCall } from '../api/client';

const AuthContext = createContext(null);

function readStoredUser() {
  try {
    const stored = localStorage.getItem('user');
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(readStoredUser);

  const login = useCallback(async (email, password) => {
    const data = await apiCall(client.post('/users/login', { email, password }));
    localStorage.setItem('token', data.token);
    localStorage.setItem('sessionId', data.uniqueLogId);
    const userObj = {
      id: data.id,
      name: data.name,
      userName: data.userName,
      isAdmin: data.isAdmin,
      activePlanId: data.activePlanId,
    };
    localStorage.setItem('user', JSON.stringify(userObj));
    setUser(userObj);
    return userObj;
  }, []);

  const signup = useCallback((payload) => {
    return apiCall(client.post('/users/sign_up', payload));
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('token');
    localStorage.removeItem('sessionId');
    localStorage.removeItem('user');
    setUser(null);
  }, []);

  return (
    <AuthContext.Provider value={{ user, login, signup, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
